import { addDays, subDays } from "date-fns";
import { useBrowserState } from "rylak-common/src/hooks/useBrowserState.jsx";
import { getCurrentDateClient } from "~/cores/appCore.js";

const DATE_SPLITTER = "||";
const SESSION_STORAGE_TIME_IN_HOURS = 12;

export function formatMetabaseDate(dateRanges) {
    if (!dateRanges) return null;
    const { startDate, endDate } = dateRanges;

    const modifiedStartDate = startDate && addDays(startDate, 1);
    const modifiedEndDate = endDate && addDays(endDate, 1);

    const toISO = (date) => date?.toISOString().split("T")[0];

    if (modifiedStartDate && modifiedEndDate) {
        return `${toISO(modifiedStartDate)}~${toISO(modifiedEndDate)}`;
    } else if (modifiedStartDate || modifiedEndDate) {
        return toISO(modifiedStartDate || modifiedEndDate);
    }

    return null;
}

export default function useMetabaseDates(appProps) {
    const maxDate = addDays(getCurrentDateClient(appProps), -1);
    const defaultStartDate = subDays(maxDate, 29);
    const defaultEndDate = maxDate;

    const datesToIsoString = ({ startDate, endDate }) => startDate?.toISOString() + DATE_SPLITTER + endDate?.toISOString();

    const isoStringDatesToDates = (isoStringDates) => {
        const splitted = isoStringDates.split(DATE_SPLITTER);
        const startDate = new Date(splitted[0]);
        const endDate = new Date(splitted[1]);
        return {
            startDate: isNaN(startDate?.getTime()) ? defaultStartDate : startDate,
            endDate: isNaN(endDate?.getTime()) ? defaultEndDate : endDate,
        };
    };

    const originalSelectedDatesAsIsoString = datesToIsoString({ startDate: defaultStartDate, endDate: defaultEndDate });

    const [selectedDatesAsIsoStrings, setSelectedDatesAsIsoStrings] = useBrowserState({
        key: "dates",
        defaultValue: originalSelectedDatesAsIsoString,
        includeQuery: true,
        timeInHours: SESSION_STORAGE_TIME_IN_HOURS,
    });

    const [timeGroupingSelected, setTimeGroupingSelected] = useBrowserState({
        key: "timeGrouping",
        defaultValue: "",
        includeQuery: true,
        timeInHours: SESSION_STORAGE_TIME_IN_HOURS,
    });

    const selectedDates = selectedDatesAsIsoStrings ? isoStringDatesToDates(selectedDatesAsIsoStrings) : null;
    const originalSelectedDatesAsDates = isoStringDatesToDates(originalSelectedDatesAsIsoString);

    return {
        maxDate,
        selectedDates,
        selectedDatesAsIsoStrings,
        originalSelectedDatesAsDates,
        setDatesSelected: (dates) => setSelectedDatesAsIsoStrings(datesToIsoString(dates)),
        timeGroupingSelected,
        setTimeGroupingSelected,
        formattedDate: formatMetabaseDate(selectedDates),
    };
}
